import { useSelector, shallowEqual } from 'react-redux';

import { useMeterType } from 'hooks/useMeterType';

import { selectIsActionUpsell } from 'state/settings/settings-slice';
import { usePartner } from 'components/app/routes/usePartner';

function getIsUpsellEnabledForElec(
  isActionUpsell: boolean,
  hasElectricityMeter: boolean,
  isRelatedElectricityMeter: boolean,
  isBGECustomerForElec: boolean,
  isUnsupportedElectricityMeter: boolean,
  isBGECustomerForGas: boolean
) {
  return (
    isActionUpsell &&
    hasElectricityMeter &&
    !isRelatedElectricityMeter &&
    !isBGECustomerForElec &&
    !isUnsupportedElectricityMeter &&
    isBGECustomerForGas
  );
}

function getIsUpsellEnabledForGas(
  isActionUpsell: boolean,
  hasGasMeter: boolean,
  isBGECustomerForGas: boolean,
  isUnsupportedGasMeter: boolean,
  isBGECustomerForElec: boolean
) {
  return (
    isActionUpsell &&
    hasGasMeter &&
    !isBGECustomerForGas &&
    !isUnsupportedGasMeter &&
    isBGECustomerForElec
  );
}

function getIsUpsellEnabledElecMeterValidationRequired(
  isActionUpsell: boolean,
  hasElectricityMeter: boolean,
  isBGECustomerForGas: boolean,
  hasGasMeter: boolean
) {
  return (
    isActionUpsell && !hasElectricityMeter && isBGECustomerForGas && hasGasMeter
  );
}

function getIsUpsellEnabledGasMeterValidationRequired(
  isActionUpsell: boolean,
  hasGasMeter: boolean,
  isBGECustomerForElec: boolean,
  hasElectricityMeter: boolean,
  isRelatedElectricityMeter: boolean
) {
  return (
    isActionUpsell &&
    !hasGasMeter &&
    isBGECustomerForElec &&
    hasElectricityMeter &&
    !isRelatedElectricityMeter
  );
}

export const useIsUpsell = () => {
  const { isDSJourney } = usePartner();
  const isActionUpsell =
    useSelector(selectIsActionUpsell, shallowEqual) && isDSJourney;
  const {
    isBGECustomerForElec,
    isBGECustomerForGas,
    isUnsupportedElectricityMeter,
    isUnsupportedGasMeter,
    hasGasMeter,
    hasElectricityMeter,
    isRelatedElectricityMeter
  } = useMeterType();

  const isUpsellEnabledForElec = getIsUpsellEnabledForElec(
    isActionUpsell,
    hasElectricityMeter,
    isRelatedElectricityMeter,
    isBGECustomerForElec,
    isUnsupportedElectricityMeter,
    isBGECustomerForGas
  );

  const isUpsellEnabledForGas = getIsUpsellEnabledForGas(
    isActionUpsell,
    hasGasMeter,
    isBGECustomerForGas,
    isUnsupportedGasMeter,
    isBGECustomerForElec
  );

  const isUpsellEnabledElecMeterValidationRequired = getIsUpsellEnabledElecMeterValidationRequired(
    isActionUpsell,
    hasElectricityMeter,
    isBGECustomerForGas,
    hasGasMeter
  );

  const isUpsellEnabledGasMeterValidationRequired = getIsUpsellEnabledGasMeterValidationRequired(
    isActionUpsell,
    hasGasMeter,
    isBGECustomerForElec,
    hasElectricityMeter,
    isRelatedElectricityMeter
  );

  const isUpsellEnabledMeterValidationRequired =
    isUpsellEnabledGasMeterValidationRequired ||
    isUpsellEnabledElecMeterValidationRequired;

  return {
    isUpsellEnabled: isUpsellEnabledForElec || isUpsellEnabledForGas,
    isUpsellEnabledForElec,
    isUpsellEnabledForGas,
    isActionUpsell,
    isUpsellEnabledMeterValidationRequired,
    isUpsellEnabledGasMeterValidationRequired,
    isUpsellEnabledElecMeterValidationRequired
  };
};
